NProgress.configure({
    minimum: 0.08,
    easing: "ease",
    speed: 500,
    showSpinner: false
});

$(document).on('click', 'a, div[class~=tile]', function() {
    if (($(this).is('a') && $(this).attr('target') === '_blank')
        || $(this).attr('data-disable-nprogress') === "true") {
        $(window).off('beforeunload');
    }
});

$(window).bind('beforeunload',function() {
    NProgress.start();
});

$(window).on("load",function() {
    NProgress.done();
});
